import { Component, ReactNode } from 'react';

interface IErrorHandlerProps {
  onError: (error: Error) => void;
  children: ReactNode;
}

export class ErrorHandler extends Component<IErrorHandlerProps> {
  componentDidCatch(error: Error): void {
    this.props.onError(error);
  }

  render(): ReactNode {
    return this.props.children;
  }
}
